<template>
  <div class="pdf-viewer">
    <div class="pdf-viewer__header box-shadow">
      <div class="pdf-viewer-toolbar">
        <div class="pdf-preview-toggle">
          <a @click.prevent.stop="togglePreview" class="icon"></a>
        </div>

        <PDFPaginator v-model="currentPage" :pageCount="pageCount" class="toolbar-item" />

        <PDFZoom :scale="scale" @change="updateScale" @fit="updateFit" class="toolbar-item" />

        <slot name="header"></slot>
      </div>
    </div>

    <PDFData class="pdf-viewer__main" :url="url" @page-count="updatePageCount" @page-focus="updateCurrentPage"
      @document-rendered="onDocumentRendered" @document-errored="onDocumentErrored">
      <template v-slot:preview="{ pages }">
        <PDFPreview v-show="isPreviewEnabled" class="pdf-viewer__preview"
          v-bind="{ pages, scale, currentPage, pageCount, isPreviewEnabled }" />
      </template>

      <template v-slot:document="{ pages }">
        <PDFDocument class="pdf-viewer__document" :class="{ 'preview-enabled': isPreviewEnabled }"
          v-bind="{ pages, scale, optimalScale, fit, currentPage, pageCount, isPreviewEnabled }"
          @scale-change="updateScale" :watermark="watermark" />
      </template>
    </PDFData>
  </div>
</template>

<script>
// import PreviewIcon from '../assets/icon-preview.svg';

import PDFDocument from './PDFDocument';
import PDFData from './PDFData';
import PDFPaginator from './PDFPaginator';
import PDFPreview from './PDFPreview';
import PDFZoom from './PDFZoom';

function floor(value, precision) {
  const multiplier = Math.pow(10, precision || 0);
  return Math.floor(value * multiplier) / multiplier;
}

export default {
  name: 'PDFViewer',

  components: {
    PDFDocument,
    PDFData,
    PDFPaginator,
    PDFPreview,
    PDFZoom,
    // PreviewIcon,
  },

  props: {
    url: String,
    watermark: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      scale: undefined,
      optimalScale: undefined,
      fit: undefined,
      currentPage: 1,
      pageCount: undefined,
      isPreviewEnabled: false,
    };
  },

  methods: {
    onDocumentRendered() {
      this.$emit('document-errored', this.url);
    },

    onDocumentErrored(e) {
      this.$emit('document-errored', e);
    },

    updateScale({ scale, isOptimal = false }) {
      const roundedScale = floor(scale, 2);
      if (isOptimal) this.optimalScale = roundedScale;
      this.scale = roundedScale;
    },

    updateFit(fit) {
      this.fit = fit;
    },

    updatePageCount(pageCount) {
      this.pageCount = pageCount;
    },

    updateCurrentPage(pageNumber) {
      this.currentPage = pageNumber;
    },

    togglePreview() {
      this.isPreviewEnabled = !this.isPreviewEnabled;
    },
  },

  watch: {
    url() {
      this.currentPage = undefined;
    },
  },

  mounted() {
    document.body.classList.add('overflow-hidden');
  },
};
</script>

<style scoped>
.pdf-viewer {
  width: 100%;
  height: 100dvh;
}

.pdf-viewer__header {
  z-index: 11;
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  text-align: center;
}

.pdf-viewer-toolbar {
  background: rgba(0, 0, 0, 0.65);
  display: inline-flex;
  align-items: center;
  padding: 0px 20px 0 10px;
  border-radius: 3px;
}

.header-item {
  margin: 0 2.5em;
}


.pdf-viewer__preview {
  display: block;
  width: 15%;
  right: 85%;
}

.pdf-viewer__document {
  width: 100%;
  left: 0;
}

.pdf-viewer__document.preview-enabled {
  width: 85%;
  left: 15%;
}

@media print {
  header {
    display: none;
  }
}
</style>
